<div class="row" *ngIf="!isQuestionPopup && hasProFeatures">
    <div class="col-md-12">
        <div class="text-right">
            <div>
                <mat-card class="cardWithShadow">
                    <mat-card-header class="card-header">
                        <mat-card-title>{{ 'CUSTOM_FORMS' | translate }}</mat-card-title>

                        <div style="display: flex; align-items: center; gap: 10px;">
                            <mat-form-field appearance="outline" class="w-100 hide-hint">
                                <input matInput [(ngModel)]="search" (keyup)="applyFilter()"
                                    placeholder="{{'SEARCH_CUSTOM_FORM' | translate}}" #input />
                            </mat-form-field>

                            <button class="m-l-15" mat-mini-fab color="primary" matTooltip="{{ 'Add' | translate}}"
                                (click)="addCustomForm(); currentStep = 0">
                                <mat-icon>add</mat-icon>
                            </button>
                        </div>

                    </mat-card-header>
                    <mat-card-content>
                        <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
                        <table mat-table *ngIf="filteredFormList" [dataSource]="filteredFormList"
                            class="mat-table expandable no-data-found-main">
                            <!-- Columnas -->
                            <ng-container matColumnDef="typeform">
                                <th mat-header-cell *matHeaderCellDef> {{ 'FORM' | translate }} </th>
                                <td mat-cell *matCellDef="let row">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div class="form-name">
                                            <div class="form-list-name d-flex flex-column cursor-pointer">
                                                <span class="font-medium form-title">
                                                    <strong>{{ row?.name?.length > 20 ? (row?.name | slice: 0 : 20) +
                                                        '...'
                                                        :
                                                        row?.name
                                                        }}</strong>
                                                </span>
                                                <span class="date">Created: {{ row.createdAt !== 'Invalid Date' ?
                                                    (row.createdAt
                                                    | date: 'd MMM y') : '-' }}</span>
                                            </div>
                                        </div>

                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="questions">
                                <th mat-header-cell *matHeaderCellDef> {{ 'QUESTIONS' | translate }} </th>
                                <td mat-cell *matCellDef="let row">
                                    <span class="active-td py-1 px-2 bg-primary">{{ row.questions.length }}</span>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="updated">
                                <th mat-header-cell *matHeaderCellDef> {{ 'UPDATED' | translate }} </th>
                                <td mat-cell *matCellDef="let row">
                                    {{ row.updatedAt !== 'Invalid Date' ? (row.updatedAt | date: 'd MMM y') : '-' }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="actions">
                                <th mat-header-cell *matHeaderCellDef> {{ 'ACTIONS' | translate }} </th>
                                <td mat-cell *matCellDef="let row">
                                    <div style="display: flex; gap: 5px;">
                                        <div class="actions">
                                            <button class="reset-btn"
                                                (click)="goToCustomFormDetails(row.ID); currentStep = 0; $event.stopPropagation()"><tabler-icon
                                                    name="edit" size="20" style="color: gray;"></tabler-icon></button>
                                        </div>

                                        <div class="actions">
                                            <button class="reset-btn" (click)="deleteForm(row.ID, $event)">
                                                <tabler-icon name="trash" size="20" style="color: gray;"></tabler-icon>
                                            </button>
                                        </div>
                                    </div>
                                </td>
                            </ng-container>

                            <!-- Filas de la tabla -->
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="clickable-row"
                                (click)="seeCustomForm(row.ID, row.referenceId)"></tr>
                        </table>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </div>
</div>

<div class="qrBox" *ngIf="isScnAccess">
    <p>Please Scan And Access Form</p>
    <qrcode [qrdata]="scanLink" [width]="150" [errorCorrectionLevel]="'M'"></qrcode>
    <button (click)="scanBack()" class="backButton">Back</button>
</div>

<p-dialog header="Pro features" [(visible)]="isModalVisible" [closable]="false" [modal]="true"
    [style]="{ width: '40vw' }" [draggable]="false" [resizable]="false">
    <p class="m-0">
        Unlock exclusive features and take your experience to the next level. With Pro Features, you'll get access to a
        range of benefits including:
    </p>
    <ul>
        <li>Access to custom forms: Create tailored forms that suit your specific needs, collecting exactly the
            information you require from your users.</li>
        <li>Linked account to Stripe: Seamlessly integrate your account with Stripe, allowing you to manage payments and
            subscriptions effortlessly.</li>
        <li>Future features: Gain early access to upcoming features and enhancements, ensuring you're always at the
            forefront of innovation.</li>
    </ul>
    <p>Don't miss out on this opportunity to elevate your usage!</p>
    <div class="text-center">
        <p-button styleClass="p-button-sm" label="Subscribe Now"></p-button>
    </div>
</p-dialog>


<p-dialog header="{{ 'CREATE_CUSTOM_FORM' | translate }}" [(visible)]="showCustomFormPopup" [draggable]="false"
    position="center" [style]="{width: '30vw'}" [modal]="true">
    <form [formGroup]="createCustomForm" (ngSubmit)="createNewForm()">
        <div class="custom-form-popup">
            <label class="w-100"> {{ 'FORM_NAME' | translate }}:</label>

            <input class="form-control mt-1" formControlName="name" type="text">
            <div class="validation-error"
                *ngIf="createCustomForm.controls['name'].invalid && (createCustomForm.controls['name'].dirty || createCustomForm.controls['name'].touched)">
                <div *ngIf="createCustomForm.controls['name'].errors?.['required']">
                    Please enter form name
                </div>
                <div *ngIf="createCustomForm.get('name').hasError('noWhiteSpaceValidator')">
                    Please enter valid form name
                </div>
            </div>

            <div class="create-custom-form-button">
                <p-button type="submit" label="{{ 'CREATE' | translate }}" iconPos="right" [loading]="isFormSubmitting"
                    styleClass="p-button-sm" [disabled]="isFormSubmitting"></p-button>
            </div>
        </div>
    </form>
</p-dialog>

<p-dialog [(visible)]="showProFeaturesModal" [baseZIndex]="10000" [draggable]="false" [modal]="true">

    <ng-template pTemplate="header">
        <div style="display: flex; justify-content: space-between; align-items: center;">
            <div style="display: flex; align-items: center; gap: 1rem;">
                <label style="font-size: 20px;">{{ 'SUBSCRIBE_PRO_FEATURES' | translate }}</label>
                <button mat-raised-button color="primary" (click)="buyPROSubscription()">{{ 'SUBSCRIBE' | translate
                    }}</button>
            </div>
        </div>
    </ng-template>

    <app-pro-features-swiper></app-pro-features-swiper>
</p-dialog>